import { getFixtureCardProps } from "../getFixtureCardProps";
import { getOutrightCardProps } from "../getOutrightCardProps";
import { getAggregateCardProps } from "../getAggregateCardProps";
import { EventsBySportIdRequest } from "sb-bff-integration";
export const EventCardPropsMapper = {
    [EventsBySportIdRequest.EventTypesEnum.Fixture]: (state, event, cms, dict) => getFixtureCardProps(state, event, cms, dict),
    [EventsBySportIdRequest.EventTypesEnum.AggregateFixture]: (state, event, dict) => getAggregateCardProps(state, event, dict),
    [EventsBySportIdRequest.EventTypesEnum.Outright]: (state, event, cms, dict) => getOutrightCardProps(state, event, cms, dict)
};
//# sourceMappingURL=EventCardPropsMapper.js.map